'use client'

import { useState } from 'react'

const useAsyncButtonProps = <
  P extends Array<unknown>,
  T extends (...parameters: P) => Promise<unknown>,
>(
  action: T,
  ...parameters: P
) => {
  const [isLoading, setIsLoading] = useState(false)

  return {
    isLoading,
    disabled: isLoading,
    async onClick() {
      setIsLoading(true)
      await action(...parameters)
      setIsLoading(false)
    },
  }
}

export default useAsyncButtonProps
